import { TextField } from '@mui/material';
import * as React from 'react';
import { TTextInput } from './TextInput.types';

export const TextInput: TTextInput = (props) => {
  return <TextField fullWidth {...props} />;
};
